export default (axios, baseURL) => async (params, clientSid) => {
  const url = `/v2/clients/${encodeURIComponent(clientSid)}/excursion-types`;

  const axiosConfig = {
    method: 'GET',
    baseURL,
    url,
    params
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
